import { useRoutes } from 'react-router-dom';
import SiteLayout from '@/components/layout/SiteLayout';
import About from '@/pages/About';
import ComingSoon from '@/pages/ComingSoon';
import Contact from '@/pages/Contact';
import Home from '@/pages/Home';
import Products from '@/pages/Products';
import Services from '@/pages/Services';

const comingSoon = import.meta.env.VITE_COMING_SOON === 'true';

const siteRoutes = [
  { path: '/about', element: <About /> },
  { path: '/products', element: <Products /> },
  { path: '/services', element: <Services /> },
  { path: '/contact', element: <Contact /> },
];

function Router() {
  const routes = useRoutes(
    comingSoon
      ? [
          { path: '/', element: <ComingSoon /> },
          {
            element: <SiteLayout />,
            children: siteRoutes,
          },
        ]
      : [
          {
            element: <SiteLayout />,
            children: [{ path: '/', element: <Home /> }, ...siteRoutes],
          },
        ]
  );

  return routes;
}

export default Router;
